module.exports = __webpack_public_path__ + "img/so.4ba090c9.svg";